import {
    apiActivateDevice,
    apiCreateDevice,
    apiDeactivateDevice,
    apiDeleteDevice,
    apiEditDevice,
    apiGetDeviceConnectionSettings,
    apiGetDeviceDetail,
    apiGetDeviceEvents,
    apiGetDeviceManufacturers,
    apiGetDeviceMessages,
    apiGetAllDeviceMessages,
    apiGetDeviceModels,
    apiGetDevices,
    apiPingDevice,
    apiUpdateConnection,
} from '../api/devices/devices';
import { TConnectionDetails, TCreateDeviceProp } from '../context/DeviceProvider';

interface DeviceListOptions {
    limit: number;
    offset: number;
    search?: string;
    manufacturers?: string[];
    models?: string[];
    statuses?: string[];
}

export const deviceService = {
    async getDevices(options: DeviceListOptions) {
        return await apiGetDevices(options);
    },

    async getDeviceModels() {
        return await apiGetDeviceModels();
    },

    async getDeviceManufacturers() {
        return await apiGetDeviceManufacturers();
    },

    async getDeviceDetail(id: number) {
        return await apiGetDeviceDetail(id);
    },

    async createDevice(data: TCreateDeviceProp) {
        return await apiCreateDevice(data);
    },

    async editDevice(id: number, data: TCreateDeviceProp) {
        return await apiEditDevice(id, data);
    },

    async pingDevice(id: number) {
        return await apiPingDevice(id);
    },

    async deactivateDevice(id: number) {
        return await apiDeactivateDevice(id);
    },
    async activateDevice(id: number) {
        return await apiActivateDevice(id);
    },

    async deleteDevice(id: number) {
        return await apiDeleteDevice(id);
    },

    async getDeviceEvents(id: number) {
        return await apiGetDeviceEvents(id);
    },

    async getDeviceMessages(id: number) {
        return await apiGetDeviceMessages(id);
    },

    async GetAllDeviceMessages(id: number, offset: number) {
        return await apiGetAllDeviceMessages(id, offset);
    },

    async getDeviceConnectionSettings(id: number) {
        return await apiGetDeviceConnectionSettings(id);
    },

    async updateConnection(id: number, params: TConnectionDetails) {
        return await apiUpdateConnection(id, params);
    },
};
